import { render, staticRenderFns } from "./reservations-graph.vue?vue&type=template&id=22631df9&scoped=true&"
import script from "./reservations-graph.vue?vue&type=script&lang=ts&"
export * from "./reservations-graph.vue?vue&type=script&lang=ts&"
import style0 from "./reservations-graph.vue?vue&type=style&index=0&id=22631df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22631df9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
